import createReducer from 'Rentlio/state/utils/createReducer'

const initialState = {}

/** used only on offers screen **/
const offer = createReducer(initialState)({})

export default offer
